import { RedmineProjectSelect } from './RedmineProjectSelect'

/**
 * Chip on an opportunity card that opens the Redmine project dropdown.
 * Thin wrapper over `RedmineProjectSelect` (chip variant); the dropdown is
 * portalled so the card's overflow/hover transform cannot clip it.
 */

interface Props {
    opportunityId: number
    identifier?: string | null
    projectName?: string | null
    canEdit: boolean
    onLinked: () => void
}

export const RedmineCardPicker = ({ opportunityId, identifier, projectName, canEdit, onLinked }: Props) => (
    <span onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <RedmineProjectSelect
            variant="chip"
            opportunityId={opportunityId}
            identifier={identifier}
            projectName={projectName}
            canEdit={canEdit}
            onChange={onLinked}
        />
    </span>
)

export default RedmineCardPicker
